import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EcryptServiceService } from '../core/auth/EcryptionService/ecrypt-service.service';

@Injectable({
  providedIn: 'root'
})
export class WhatsappCampaignService {

  url = environment.serverAPI8 + "/api/whatsappcampaign";

  whatsappVendorId: any;
  crmSettingsData: any;

  constructor(private http: HttpClient, private ecryptService: EcryptServiceService) { }
  sheduleCampaign(campaigndata: any): Observable<string> {

    let accessToken = null;
    let whatsappUrl = null;
    let currentPhoneNumberId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

      accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
      console.log(accessToken);
      currentPhoneNumberId = this.ecryptService.encrypt(this.crmSettingsData.currentPhoneNumberId);
    }

    let params = new HttpParams();

    params = params
      .set('act', accessToken)
      .set('cpid', currentPhoneNumberId);


    return this.http.post<string>(`${this.url}/schedule/template`, campaigndata, { params });
  }

  campaignSearch(query, Page: any, size: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}`);

  }

  searchWhatsAppCampaign(query: string, page: number, size: number, sort: string): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; // Construct query parameters


    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }
  searchWhatsAppCampaignNew(query: string, page: number, size: number, sort: string): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; // Construct query parameters


    return this.http.post<Response[]>(`${this.url}/archived/list-data${queryParams}`, requestBody);
  }
  searchWhatsAppCampaignQueue(query: string, page: number, size: number, sort: string, CampaignUuid): Observable<Response[]> {
    const cleanQuery = typeof query === 'string' ? query.split("'").join('') : '';

    const requestBody = {
      searchQuery: cleanQuery
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/queue/${CampaignUuid}${queryParams}`, requestBody);
  }

  searchWhatsAppCampaignExecuted(query: string, page: number, size: number, sort: string, CampaignUuid): Observable<Response[]> {
    const cleanQuery = typeof query === 'string' ? query.split("'").join('') : '';

    const requestBody = {
      searchQuery: cleanQuery
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/executed/${CampaignUuid}${queryParams}`, requestBody);
  }

  viewDashBoard(campaignId: string): Observable<any> {
    const url = `${environment.serverAPI8}/api/campaign/status/${campaignId}/view/ajax`;
    return this.http.get(url);
  }

  deleteProcess(uid: string): Observable<any> {

    return this.http.delete<any>(`${this.url}/${uid}/delete-process`);
  }

  toggleCampaignStatus(uid: string, active: boolean, reason?: string): Observable<any> {
    const body: any = { active };
    if (reason) body.reason = reason;
    const url = `${environment.serverAPI8}/api/campaign/${uid}/toggle-status`;
    return this.http.post<any>(url, body);
  }

  isLoading = new Subject<boolean>();

  show() {
    this.isLoading.next(true);

  }

  filterLeads(searchQuery: string, page: number, size: number, sort: string): Observable<any> {
    const url = environment.serverAPI9 + '/api/leadEntity/filter';
    return this.http.get<any>(`${url}?search=${encodeURIComponent(searchQuery)}&page=${page}&size=${size}&sort=${sort}`);
  }

}
